import { Title, Text, DetailText } from "../../components/units/Text"
import { useState } from "react"
import { OrganizationProps } from "../../interfaces/Organization"
import { FetchMyOrganization, FetchStaffOrganization } from "../../components/Rest/Organization"
import { useEffect } from "react"
import { LoadingView } from "../../components/Loading/Loading"
import { ContentWrapper, BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import "./Organization.css"
import { FC } from 'react';
import { useSignedInContext } from "../../context/AuthContextProvider"
import { Client } from "../../roles/roles"
import { 
    ACBRangedListParams, 
    ClientFetchACBRangedList, 
    ACBRangedListResponse, 
    StaffFetchACBRangedList, 
    AxiosFetchGrpDevice,
    DeviceListResponse,
    AxiosFetchGrpBuildings
} from "../../components/Rest/RestAcbList"
import { ConditionalWrapper } from "../../components/Wrappers/Wrappers"
import { AcbRangedTable } from "../../components/Accumulator/Table"
import { DateRangePicker } from '../../components/Pickers/dataRange';
import { DateRangeEnum } from "../../interfaces/DatePicker/types"
import { Divider } from "../../components/units/Divider"
import { SearchField } from "../../components/SearchFields/SearchFields"
import { useParams } from "react-router-dom";
import { UserModel } from "../../context/AuthContextProvider"
import { useNavigate } from "react-router-dom"
import { TableFilter } from "../../components/Pickers/tableFilters"
import { DeviceTable } from "../../components/Accumulator/DeviceTable"
import { BuildingTable } from "../../components/Accumulator/BuildingTable"


const OrganizationAvatar = (details: OrganizationProps) => {
    if (details.organization_image === null) {
        return (
            <div className="organization-image flex align-center justify-center">
                <Text color="secondary" size="xxxxl">{details.organization_name.slice(0,1).toUpperCase()}</Text>
            </div>
        )
    } else {
        return (
            <div className="organization-image flex align-center justify-center">
                <img className="organization-img" src={`${process.env.REACT_APP_DJANGO_SERVER_URL}${details.organization_image}`} alt="" />
            </div>
        )
    }
}



const EditIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.81145 7.1737C5.17656 7.80856 4.77786 8.49869 4.54562 9.36652L3.77521 12.2414L6.64233 11.473C7.51472 11.2395 8.20817 10.8369 8.84568 10.1967L13.0333 5.98961L10.0055 2.98045L5.81131 7.17444L5.81145 7.1737ZM13.7499 8.25C13.7499 7.76645 14.142 7.37501 14.6249 7.37501C15.1085 7.37501 15.4999 7.76645 15.4999 8.25V12.4394C15.4999 14.4012 13.9012 16 11.9392 16H3.5607C1.5982 16 0 14.4013 0 12.4394V4.06056C0 2.09881 1.59874 0.5 3.5607 0.5H7.7503C8.23387 0.5 8.62533 0.891441 8.62533 1.37499C8.62533 1.85854 8.23321 2.24998 7.7503 2.24998H3.5607C2.56461 2.24998 1.75079 3.06444 1.75079 4.05982V12.438C1.75079 13.4341 2.56528 14.2479 3.5607 14.2479H11.9392C12.9353 14.2479 13.7491 13.4334 13.7491 12.438V8.24858L13.7499 8.25ZM14.0716 4.94678L11.0458 1.93965L11.8663 1.11926C12.3834 0.602163 13.1045 0.408733 13.7735 0.539663C14.1913 0.621242 14.5604 0.816629 14.8808 1.13703C15.694 1.95018 15.7177 3.29364 14.8841 4.13103L14.0715 4.94747L14.0716 4.94678Z" fill="#A8A8A8"/>
        </svg>
    )
}

const AddBtn = ({ path }:any) => {
    const navigate = useNavigate();

    return (
        <div style={{width: '30px', height: '30px'}} onClick={ (e) => { navigate(path) } }>
            <BoxWrapper 
                bg="bg-black" 
                style={{width: '30px', height: '30px', boxShadow: "4px 4px 6px 0px rgba(0, 0, 0, 0.2)"}} 
                r="r5"
                p="p0"
                className="flex align-center justify-center"
            >
                <div style={{position:'absolute', width: '3px', height:"20px", borderRadius:"2px"}} className="bg-light"></div>
                <div style={{width: '3px', height:"20px", rotate:"90deg", borderRadius:"2px"}} className="bg-light"></div>
    
            </BoxWrapper>
        </div>
    )
}


const OrganizationInfo = (details: OrganizationProps, user: UserModel) => {
    const editUrl = `/react/organization/${details.id}/edit/organization`
    
    return (
        <>
        <BoxWrapper className="flex space-between align-center show-up" p="p0">
            <Title>{details.organization_name}</Title>
            <DetailText href={ editUrl }>
                <div className="flex narrow-gap">
                    <EditIcon/>
                    <Text color="secondary">Редактировать</Text>
                </div>
            </DetailText>
        </BoxWrapper>
        <br />
        <BoxWrapper className="flex wide-gap flex-wrap show-up relative" p="p0">
            { OrganizationAvatar(details) }
            <div className="flex inner-box flex-grow gray-border-top margin p2-top wide-gap flex-wrap full-width">
                <div className="organization-info flex flex-column space-between">
                    <div className="flex wide-gap">
                        <Text color="orange" className="organization-info-label">Адрес:</Text>
                        <Text color="primary">{details.address}</Text>
                    </div>
                    <div className="flex wide-gap">
                        <Text color="orange" className="organization-info-label">Телефон:</Text>
                        <Text color="primary">{details.phone}</Text>
                    </div>
                    <div className="flex wide-gap">
                        <Text color="orange" className="organization-info-label">Почта:</Text>
                        <Text color="primary">{details.email}</Text>
                    </div>
                </div>
                <div className="organization-prop-cards-wrapper flex normal-gap">
                    <div className="organization-entity">
                        <FlexWrapper alignItems="start" className="full-height">
                            <FlexWrapper alignItems="start" flexDirection="column">
                                <Text className="bold display-block">Объекты</Text>
                                <svg className="no-animation" width="58" height="56" viewBox="0 0 58 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.8195 15.3759C14.8195 11.5237 17.9488 8.39453 21.8175 8.39453H48.6968V9.78584H21.8175C18.7243 9.78584 16.217 12.2884 16.217 15.3759H14.8195Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.9952 14.6797H18.3398L18.6496 34.0781H12.3755L12.9952 14.6797ZM14.3491 16.071L13.8182 32.6868H17.2297L16.9642 16.071H14.3491Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 22.612H13.6721V21.2207H17.6519V22.612Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 26.5026H13.6721V25.1113H17.6519V26.5026Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.6519 30.3981H13.6721V29.0068H17.6519V30.3981Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M21.2263 18.3135H26.5588L26.8743 34.0785H20.5913L21.2263 18.3135ZM22.569 19.7048L22.0461 32.6872H25.4486L25.1888 19.7048H22.569Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 26.5026H21.8976V25.1113H25.8738V26.5026Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M25.8738 30.3981H21.8976V29.0068H25.8738V30.3981Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.65259 33.0684H49.3956V47.6089H9.65259V33.0684ZM11.0502 34.4597V46.2176H47.998V34.4597H11.0502Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 39.194H28.6921V37.8027H45.9514V39.194Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M45.9514 42.8786H28.6921V41.4873H45.9514V42.8786Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.9651 37.8574H25.9099V47.6055H14.9651V37.8574ZM16.3627 39.2487V46.2142H24.5123V39.2487H16.3627Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M38.3416 23.6836H49.3992V34.4563H38.3416V23.6836ZM39.7391 25.0749V33.065H48.0016V25.0749H39.7391Z" fill="#A8A8A8"/>
                                </svg>
                            </FlexWrapper>
                            <FlexWrapper flexDirection="column" justifyContent="space-between" className="full-height">
                                <AddBtn path={ `/react/organization/${details.id}/edit/buildings` } /> 
                                <Text className="bold" size='xxxl' color="orange">{details.building_count}</Text>
                            </FlexWrapper>
                        </FlexWrapper>
                        
                    </div>
                    <div className="organization-entity">
                        <FlexWrapper alignItems="start" className="full-height">
                            <FlexWrapper alignItems="start" flexDirection="column">
                                <Text className="bold display-block">Техника</Text>
                                <svg width="58" height="56" viewBox="0 0 58 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M41.2289 35.6523V9.73926H42.6265V35.6523H41.2289Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M16.7711 41.5654H30.747V42.9567H16.7711V41.5654Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M10.4766 28.3474C8.35996 28.3474 6.63856 30.0695 6.63856 32.2001V41.5648H9.36165V42.9561H5.24097V32.2001C5.24097 29.3112 7.57799 26.9561 10.4766 26.9561H16.6753C18.648 26.9561 20.497 27.9204 21.6307 29.5309L24.1982 33.1842C24.8673 34.1347 25.9531 34.6994 27.1119 34.6994H42.8012V42.9561H38.7232V41.5648H41.4036V36.0907H27.1119C25.4939 36.0907 23.9823 35.302 23.0536 33.9826L20.4862 30.3294C19.612 29.0876 18.1887 28.3474 16.6753 28.3474H10.4766Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M17.9971 11.4782C15.9697 11.4782 14.3253 13.1113 14.3253 15.1301V27.4651H12.9277V15.1301C12.9277 12.341 15.1997 10.0869 17.9971 10.0869H27.231L37.2109 27.2356V35.4782H35.8133V27.6095L26.4255 11.4782H17.9971Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M41.7531 23.1309H54.5061V24.5222H41.7531V23.1309Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M13.015 40.1735C11.2301 40.1735 9.78309 41.614 9.78309 43.3909C9.78309 45.1678 11.2301 46.6083 13.015 46.6083C14.8 46.6083 16.2469 45.1678 16.2469 43.3909C16.2469 41.614 14.8 40.1735 13.015 40.1735ZM8.3855 43.3909C8.3855 40.8456 10.4582 38.7822 13.015 38.7822C15.5718 38.7822 17.6445 40.8456 17.6445 43.3909C17.6445 45.9362 15.5718 47.9996 13.015 47.9996C10.4582 47.9996 8.3855 45.9362 8.3855 43.3909Z" fill="#A8A8A8"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M34.5031 40.1735C32.7181 40.1735 31.2711 41.614 31.2711 43.3909C31.2711 45.1678 32.7181 46.6083 34.5031 46.6083C36.288 46.6083 37.735 45.1678 37.735 43.3909C37.735 41.614 36.288 40.1735 34.5031 40.1735ZM29.8735 43.3909C29.8735 40.8456 31.9462 38.7822 34.5031 38.7822C37.0599 38.7822 39.1326 40.8456 39.1326 43.3909C39.1326 45.9362 37.0599 47.9996 34.5031 47.9996C31.9462 47.9996 29.8735 45.9362 29.8735 43.3909Z" fill="#A8A8A8"/>
                                </svg>
                            </FlexWrapper>
                            <FlexWrapper flexDirection="column" justifyContent="space-between" className="full-height">
                                <AddBtn path={ `/react/organization/${details.id}/edit/devices` } />
                                <Text className="bold" size='xxxl' color="orange">{details.client_device_count}</Text>
                            </FlexWrapper>
                        </FlexWrapper>
                    </div>
                    <div className="organization-entity">
                        <FlexWrapper alignItems="start" className="full-height">
                            <FlexWrapper alignItems="start" flexDirection="column">
                                <Text className="bold display-block">Батареи</Text>
                                <svg width="58" height="56" viewBox="0 0 58 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M46.7055 48.1374H18.7509V31.3366H20.875V30.0088H25.8727V31.3366H39.5527V30.0088H44.5504V31.3366H46.7055V48.1374ZM19.9894 46.8906H45.4669V32.5834H43.3118V31.2556H40.7913V32.5834H24.6341V31.2556H22.1136V32.5834H19.9894V46.8906Z" fill="#A8A8A8"/>
                                    <path d="M49.5422 45.799H45.9565V44.5522H48.3036V12.6463H46.4395V10.9382H46.2909V12.6463H39.9556V10.9382H39.8131V12.6463H37.9615V31.7412H36.7229V11.3995H38.5746V9.69141H41.1942V11.3995H45.0523V9.69141H47.6781V11.3995H49.5422V45.799Z" fill="#A8A8A8"/>
                                    <path d="M19.2341 45.7994H8.21082V10.4711L10.7994 7.86523H30.9944L33.583 10.4711V31.8788H32.3445V10.9885L30.4804 9.11204H11.3134L9.44939 10.9885V44.5526H19.2341V45.7994ZM26.455 14.411C25.3837 14.411 24.5167 13.532 24.5167 12.4597C24.5167 11.3875 25.3899 10.5085 26.455 10.5085C27.5202 10.5085 28.3934 11.3875 28.3934 12.4597C28.3934 13.532 27.5202 14.411 26.455 14.411ZM26.455 11.749C26.0711 11.749 25.7552 12.067 25.7552 12.4535C25.7552 12.84 26.0711 13.1579 26.455 13.1579C26.839 13.1579 27.1548 12.84 27.1548 12.4535C27.1548 12.067 26.839 11.749 26.455 11.749ZM15.345 14.411C14.2736 14.411 13.4066 13.532 13.4066 12.4597C13.4066 11.3875 14.2798 10.5085 15.345 10.5085C16.4102 10.5085 17.2834 11.3875 17.2834 12.4597C17.2834 13.532 16.4102 14.411 15.345 14.411ZM15.345 11.749C14.9611 11.749 14.6452 12.067 14.6452 12.4535C14.6452 12.84 14.9611 13.1579 15.345 13.1579C15.729 13.1579 16.0448 12.84 16.0448 12.4535C16.0448 12.067 15.729 11.749 15.345 11.749Z" fill="#A8A8A8"/>
                                </svg>
                            </FlexWrapper>
                            <FlexWrapper flexDirection="column" justifyContent="space-between" className="full-height">
                                <div></div>
                                <Text className="bold" size='xxxl' color="orange">{details.acb_count}</Text>
                            </FlexWrapper>
                        </FlexWrapper>                    
                    </div>
                </div>
            </div>
        </BoxWrapper>
        </>
    )
}


interface OrganizationHandlerPros {
    organization: (OrganizationProps | undefined),
    user: UserModel
}


const OrganizationHandler:FC<OrganizationHandlerPros> = ({ organization, user }) => {
    function component(organization: OrganizationProps | undefined) {
        if (organization !== undefined) {
            return OrganizationInfo(organization, user)
        } else {
            return LoadingView()
        } 
    }
    
    return (
        <BoxWrapper bg="bg-primary" r="r15" p="p4" className="show-up" style={{minHeight: "225px"}}>
            { component(organization) }
        </BoxWrapper>
    )
}

export enum Section {
    ACBList,
    BuildingList,
    DeviceList
}

interface AcbTableProps {
    data: Array<any>
}

const AcbTable:FC<AcbTableProps> = ({ data }):JSX.Element => {
    return (
        // <Table columns={columns} data={data} />
        <div>ЕТест</div>
    )
}


const Organization = () => {
    function defaultAcbListParams(): ACBRangedListParams {
        return {
            period: 'quartal',
            limit: 10,
            currentPage: 1,
            offset: 0,
            timeout: undefined,
            dateRange: {
                isOpen: false,
                range: DateRangeEnum.Month
            },
            building: {
                isOpen: false,
                value: undefined,
            },
            client_device_type: {
                isOpen: false,
                value: undefined,
            }
        }
    }

    const organizationId = (id: any): string => {
        if (id) {
            return id
        }
        throw new Error("ID must be provided")
    }

    const { user } = useSignedInContext()
    const [organization, setOrganization] = useState<OrganizationProps | undefined>(undefined)
    const [section, setSection] = useState<Section>(Section.ACBList)
    const [acbList, setAcbList] = useState<ACBRangedListResponse | undefined>(undefined)
    const [deviceList, setDeviceList] = useState<DeviceListResponse | undefined>(undefined)
    const [buildingList, setBuildingList] = useState<DeviceListResponse | undefined>(undefined)

    const [tableParams, setTableParams] = useState<ACBRangedListParams>(defaultAcbListParams())
    const { id } = useParams();

    const setSearch = (search:string):void => {
        setTableParams((prev) => ({
            ...prev, search : search
        }))
    };

    const setDateRange = (value: DateRangeEnum) => {
            setTableParams((prev) => ({
                ...prev, 
                dateRange: {
                    ...prev.dateRange,
                    range: value
                }
            }))
    }

    const fetchAcbList = async () => {
        setAcbList((prev: any) => ({...prev, results: undefined }))
        if (user.role === Client) {
            ClientFetchACBRangedList(setAcbList, tableParams)
        } else {
            StaffFetchACBRangedList(setAcbList, {...tableParams, ...{organization: organizationId(id)}})
        }
    }

    useEffect(() => {
        const fetchList = async () => {
            if (user.role === Client) {
                FetchMyOrganization((key: string, value: any) => {
                    setOrganization(value)
                })  
            } else {
                let organization_id = organizationId(id)
                FetchStaffOrganization(organization_id, (key: string, value: any) => {
                    setOrganization(value)
                })
            }
        }
        fetchList()
    }, [user])

    useEffect(() => {
        if (section === Section.ACBList) {
            fetchAcbList()
        }

        if (section === Section.DeviceList) {
            AxiosFetchGrpDevice(user.role_slug, setDeviceList, {...tableParams, ...{organization: organizationId(organization?.id)}})
        }

        if (section === Section.BuildingList) {
            AxiosFetchGrpBuildings(user.role_slug, setBuildingList, {...tableParams, ...{organization: organizationId(organization?.id)}})
        }
        
    }, [section, tableParams.currentPage, tableParams.dateRange.range, tableParams.ordering, tableParams.building.value, tableParams.client_device_type.value])


    useEffect(() => {
        const dropTimeout = ():void => {
            clearTimeout(tableParams.timeout)
            setTableParams((prev) => ({
                ...prev, timeout : undefined
            }))

        }

        if (tableParams.search === undefined) {
            return
        }

        if (tableParams.timeout) {
            dropTimeout()
        } 

        const timeout = setTimeout(() => {
            if (section === Section.ACBList) {
                fetchAcbList()
            }
    
            if (section === Section.DeviceList) {
                AxiosFetchGrpDevice(user.role_slug, setDeviceList, {...tableParams, ...{organization: organizationId(organization?.id)}})
            }

            if (section === Section.BuildingList) {
                AxiosFetchGrpBuildings(user.role_slug, setBuildingList, {...tableParams, ...{organization: organizationId(organization?.id)}})
            }
            dropTimeout()
        }, 750) 

        setTableParams((prev) => ({
            ...prev, timeout : timeout
        }))
    }, [tableParams.search])

    return (
        <ContentWrapper>
            <OrganizationHandler 
                organization={organization} 
                user={user}
                />
            <br />
            <BoxWrapper className="selectors" p="p0">
                { (organization?.allow_building_grouping && organization?.building_count > 0) && (
                    <Text 
                        size="xl" 
                        color={ section === Section.BuildingList ? 'primary' : 'secondary' } 
                        className={`bold fit pointer show-up ${section === Section.BuildingList ? 'selected' : ''}`}
                        onClick={(e)=>setSection(Section.BuildingList)}
                        >Объекты</Text>
                ) }
                { (organization?.allow_custom_model_grouping && organization?.client_device_count > 0) && (
                    <Text 
                        size="xl" 
                        color={ section === Section.DeviceList ? 'primary' : 'secondary' } 
                        className={`bold fit pointer show-up ${section === Section.DeviceList ? 'selected' : ''}`}
                        onClick={(e)=>setSection(Section.DeviceList)}
                        >Техника</Text>
                ) }
                <Text 
                    size="xl" 
                    color={ section === Section.ACBList ? 'primary' : 'secondary' } 
                    className={`bold fit pointer show-up ${section === Section.ACBList ? 'selected' : ''}`}
                    onClick={(e)=>setSection(Section.ACBList)}
                    >
                    Батареи</Text>
            </BoxWrapper>
            {Divider()}
            <BoxWrapper p="p0">
                <div className="organization-section-grid">
                    <DateRangePicker 
                        isOpen={tableParams.dateRange.isOpen} 
                        dateRange={tableParams.dateRange.range} 
                        setDateRangeOpen={(value: boolean) => {        
                            setTableParams((prev) => ({
                                ...prev, 
                                dateRange: {
                                    ...prev.dateRange,
                                    isOpen: value
                                }
                            }   
                        ))}} 
                        setDateRange={setDateRange} />
                    <div>
                        { [Section.ACBList, Section.DeviceList].includes(section) && (
                            <BoxWrapper p="p0">
                                <TableFilter 
                                    label={"Фильтр по объекту: "}
                                    options={[
                                        ...organization ? (
                                            organization.buildings.map(item => ({
                                                value: item.id,
                                                label: item.building_name ? item.building_name : '',
                                            }))
                                        ) : (
                                            []
                                        ),
                                        {value: null, label: "Отсутсвует"},
                                    ]
                                        
                                    }
                                    selected={tableParams.building.value}  
                                    isOpen={tableParams.building.isOpen}
                                    setOpen={(isOpen:boolean) => {
                                        return void setTableParams(prev => ({
                                            ...prev , building: {
                                                ...prev.building , isOpen : isOpen
                                            }
                                        }))
                                    }}
                                    dataSetter={(value: any) => {
                                        return void setTableParams(prev => ({
                                            ...prev , building: {
                                                ...prev.building , value : value
                                            }
                                        }))
                                    }}
                                />
                            </BoxWrapper>
                        )}
                    </div>
                    <div>
                        { section === Section.ACBList && (
                            <BoxWrapper p="p0">
                                <TableFilter 
                                    label={"Фильтр по виду техники: "}
                                    options={[
                                        ...organization ? (
                                            organization.devices.map(item => ({
                                                value: item.id,
                                                label: item.device_name ? item.device_name : '',
                                            }))
                                        ) : (
                                            []
                                        ),
                                        {value: null, label: "Отсутсвует"},
                                    ]}
                                    selected={tableParams.client_device_type.value}  
                                    isOpen={tableParams.client_device_type.isOpen}
                                    setOpen={(isOpen:boolean) => {
                                        return void setTableParams(prev => ({
                                            ...prev , client_device_type: {
                                                ...prev.client_device_type , isOpen : isOpen
                                            }
                                        }))
                                    }}
                                    dataSetter={(value: any) => {
                                        return void setTableParams(prev => ({
                                            ...prev , client_device_type: {
                                                ...prev.client_device_type , value : value
                                            }
                                        }))
                                    }}
                                />
                            </BoxWrapper>
                        )}
                    </div>
                    <div>
                        { section === Section.ACBList && (
                            <SearchField timeout={tableParams.timeout} setSearch={setSearch}/>
                        )}
                    </div>
                </div>                
                </BoxWrapper>
            <br />
            <ConditionalWrapper condition={section===Section.ACBList}>
                <AcbRangedTable 
                    data={acbList} 
                    currentPage={tableParams.currentPage} 
                    itemsPerPage={tableParams.limit}
                    params={tableParams}
                    setter={(value: number) => {
                        setTableParams((prev) => ({
                            ...prev, currentPage : value
                        }))
                    }}
                    orderSetter={(value: string) => {
                        setTableParams((prev) => ({
                            ...prev, ordering : value
                        }))
                    }}
                />
            </ConditionalWrapper>
            <ConditionalWrapper condition={section===Section.DeviceList}>
                <DeviceTable 
                    data={deviceList}
                    currentPage={tableParams.currentPage} 
                    itemsPerPage={tableParams.limit}
                    params={tableParams}
                    setter={(value: number) => {
                        setTableParams((prev) => ({
                            ...prev, currentPage : value
                        }))
                    }}
                    orderSetter={(value: string) => {
                        setTableParams((prev) => ({
                            ...prev, ordering : value
                        }))
                    }}
                    setSection={(value: any, section: Section) => {
                        setTableParams((prev) => ({
                            ...prev , client_device_type: {
                                ...prev.client_device_type , value : value
                            }
                        }))
                        setSection(section)
                    }}

                />
            </ConditionalWrapper>
            <ConditionalWrapper condition={section===Section.BuildingList}>
                <BuildingTable 
                    organization={organization}
                    data={buildingList}
                    currentPage={tableParams.currentPage} 
                    itemsPerPage={tableParams.limit}
                    params={tableParams}
                    setter={(value: number) => {
                        setTableParams((prev) => ({
                            ...prev, currentPage : value
                        }))
                    }}
                    orderSetter={(value: string) => {
                        setTableParams((prev) => ({
                            ...prev, ordering : value
                        }))
                    }}
                    setSection={(value: any, section: Section) => {
                        setTableParams((prev) => ({
                            ...prev , building: {
                                ...prev.building , value : value
                            }
                        }))
                        setSection(section)
                    }}

                />
            </ConditionalWrapper>
        </ContentWrapper>
    )
}

export default Organization